import { Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
export class DragDropDirectiveService {
private dropItem = new Subject<any>();
private draggedItem:any;
constructor() { }
/**
 * @param {?} item
 * @return {?}
 */
public setDropItem(item){
  	this.dropItem.next(item);
  }
/**
 * @return {?}
 */
public getDropItem(){
  	return this.dropItem.asObservable();
  }
/**
 * @param {?} item
 * @return {?}
 */
public setDragItem(item){
    this.draggedItem = item;
  }
/**
 * @return {?}
 */
public getDragItem(){
    return this.draggedItem;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DragDropDirectiveService_tsickle_Closure_declarations() {
/** @type {?} */
DragDropDirectiveService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DragDropDirectiveService.ctorParameters;
/** @type {?} */
DragDropDirectiveService.prototype.dropItem;
/** @type {?} */
DragDropDirectiveService.prototype.draggedItem;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
